/* global axios */
import ApiClient from './ApiClient';

class WorkflowsAPI extends ApiClient {
  constructor() {
    super('workflows', { accountScoped: true });
  }

  clone(workflowId) {
    return axios.post(`${this.url}/${workflowId}/clone`);
  }

  toggle(workflowId) {
    return axios.post(`${this.url}/${workflowId}/toggle`);
  }

  test(workflowId) {
    return axios.post(`${this.url}/${workflowId}/test`);
  }

  executions(workflowId, params = {}) {
    return axios.get(`${this.url}/${workflowId}/executions`, { params });
  }

  availableConfig() {
    return axios.get(`${this.url}/available_config`);
  }
}

export default new WorkflowsAPI();
